import { createReducer, on } from '@ngrx/store';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { FundChartOptionValue } from 'ChartApp/ts/enums/fund-chart-common.enum';
import { setChartOption } from './chart-options.actions';
import { setFundChart } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart.actions';
export const useCustomColors = createReducer(false, on(setChartData, (state, { chartData }) => chartData.params.useCustomColors), on(setChartOption, (state, action) => {
    if (action.chartOption.value === FundChartOptionValue.SHOW_CUSTOM_COLORS) {
        return action.chartOption.selected;
    }
    return state;
}), on(setFundChart, (state, action) => {
    return action.fundChart[FundChartOptionValue.SHOW_CUSTOM_COLORS];
}));
